import api from '../api/axios';

const userManagementService = {
  /** Fetch all portal users */
  getAll: () => api.get('/api/admin/users'),

  /** Create a new portal user */
  create: (data) => api.post('/api/admin/users', data),

  /** Update user details (name, team, active, customRoleId, unassignRole) */
  update: (userId, data) => api.post(`/api/admin/users/${userId}`, data),

  /** Toggle active flag */
  toggleActive: (userId) => api.patch(`/api/admin/users/${userId}/toggle-active`),
};

export default userManagementService;
